import { TFunction } from "react-i18next";
import { MoneyApi } from "go-core/api/types";
import { gatewayMerchantId } from "../../../../../utils/envutil";

export const allowedPaymentMethods: google.payments.api.PaymentMethodSpecification[] = [
	{
		type: "CARD",
		parameters: {
			allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
			allowedCardNetworks: ["MASTERCARD", "VISA"],
		},
		tokenizationSpecification: {
			type: "PAYMENT_GATEWAY",
			parameters: {
				gateway: "tpaycom",
				gatewayMerchantId: gatewayMerchantId(),
			},
		},
	},
];

export const getTransactionInfo = (totalPrice: MoneyApi, t: TFunction): google.payments.api.TransactionInfo => {
	return {
		totalPriceStatus: "FINAL",
		totalPriceLabel: t("modules.e_order.field.amount_to_pay.title"),
		totalPrice: totalPrice.amount.toString(),
		currencyCode: totalPrice.currency,
		countryCode: "PL",
	};
};

export const API_VERSION = 2;
export const API_VERSION_MINOR = 0;

export const isAppleDevice = /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);

export const isSafari = (() => {
	const ua = navigator.userAgent;
	const isWebKit = /AppleWebKit/.test(ua);
	const isChromeOrEdge = /CriOS|Chrome|Chromium|Edg/i.test(ua);
	return isWebKit && !isChromeOrEdge;
})();
